/**
 * Événements de notification Socket.IO
 */
export const NOTIFICATION_EVENTS = {
  MESSAGE_RECEIVED: 'message:received',
  NOTIFICATION_NEW: 'notification:new',
  USER_ONLINE: 'user:online',
  CALL_INCOMING: 'call:incoming',
  CALL_ACCEPTED: 'call:accepted',
  CALL_REJECTED: 'call:rejected',
  CALL_ENDED: 'call:ended',
  USER_OFFLINE: 'user:offline',
  TYPING_NOTIFICATION: 'typing:notification',
} as const;

export type NotificationEventType = typeof NOTIFICATION_EVENTS[keyof typeof NOTIFICATION_EVENTS];
